import { EnginePositionModel } from '../models/engine-position.model';
import { BdGraph } from '../../../lib/graph/graph.model';
import { ViewTreeNode } from '../models/view.tree-node';
import { HitModel } from '../models/hit.model';
import { ChapterInitModel } from '../models/engine-chapter-init-model';
import { ToolEnum } from '../models/tool.enum';

export class EngineStateModel {
    loading: boolean;
    engine: string;
    ready: boolean;

    viewGraph: BdGraph<ViewTreeNode>;

    chapter: string;
    chapterInit: ChapterInitModel;

    enginePosition?: EnginePositionModel;

    showCameraBar: boolean;
    showLabels: boolean;

    activeTool: ToolEnum;
    display: boolean;
    visible: boolean;
    animationPlaying: boolean;
}
